import { useMutation } from '@tanstack/react-query';
import type { FoodNotificationSettingsDto } from '../../../models/settings/admin/food-notification-settings.dto';
import apiRequest from '../../../services/apiWrapper';
import { FOOD_PAYMENT_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';

async function updateFoodNotificationSettings(
  data: FoodNotificationSettingsDto
) {
  return apiRequest.put(FOOD_PAYMENT_NOTIFICATION_URL, data);
}

export function useUpdateFoodNotificationSettings() {
  return useMutation({
    mutationFn: (data: FoodNotificationSettingsDto) =>
      updateFoodNotificationSettings(data),
  });
}
